module.exports = __webpack_public_path__ + "img/score.c348b12e.png";